import {Injectable} from '@angular/core';
import { catchError, forkJoin, from, map, Observable, of, retry, Subject, throwError} from 'rxjs';
import { MemberModel} from '../../../models/user.model';
import { ContractWrapperModel } from '../../../models/contract.model';
import { FinanceService } from '../../../services/api/finance.service';
import { IForecast, IWallet, IWalletFullData } from '../models/contract-internal-models';

@Injectable({
    providedIn: 'root'
})
export class ContractFinanceService {
  //public suburrentWalletData$:Subject<IWalletFullData> = new Subject() 
  constructor(
    private financeService:FinanceService,
  ) { }
    getCurrentWalletAndForecasts(contract: ContractWrapperModel, currentMember:MemberModel,currentProjectGuid:string, guidWallet?:string)
    : Observable<IWalletFullData> {
        let privateWalletGuid = contract.privates.find(person => person.member.guid === currentMember.guid)?.wallet_guid
        let projectWalletGuid = contract.projects.find(company => company.project.guid === currentProjectGuid)?.wallet_guid;
        let partyWalletGuid = guidWallet||privateWalletGuid || projectWalletGuid
        let requests:{
          wallet:Observable<IWallet>,
          forecast:Observable<IForecast>
        } 
        if (currentMember.person) {
          requests = { 
            wallet:this.financeService.getPrivateWalletByGuid(partyWalletGuid || ''),
            forecast:this.financeService.getForecastPrivateWallets()
          }
        } else {
          requests = { 
            wallet:this.financeService.getWalletByGuid(partyWalletGuid || ''),
            forecast:this.financeService.getMoneyInfo()
          }
        }
        return forkJoin({
            wallet:requests.wallet,
            forecast:requests.forecast,
            contractGuid:of(''),
            currentForecast:of({})
          }).pipe(
            map(data=>{
              let currentForecast = data.forecast?.forecast.forecast_wallets?.find(el=>el.wallet?.guid === data.wallet.wallet.guid)
              currentForecast? data.currentForecast = currentForecast : null,
              data.contractGuid = contract.contract.guid
              return data
            }),
            catchError(e=>throwError(()=>new Error(e))))
    }
}    